import { getAppConfig } from '@/letapps-vue/utils/appConfig';
import axios from 'axios';
import dayjs from 'dayjs';
import { defineStore } from 'pinia';
import { ref } from 'vue';

function aarstal() {
  const result = [];
  const indevaerendeAar = dayjs().year();
  for (let i = 0; i < 4; i++) {
    const aar = indevaerendeAar - i;
    result.push({ aarstal: '' + aar, checked: false });
  }
  return result;
}
const initialFilterValue = {
  opslagType: {
    nyhed: { text: 'Nyhed', checked: false },
    vejledning: { text: 'Vejledning', checked: false },
    indhold: { text: 'Indhold', checked: false },
    produktbeskrivelse: { text: 'Produktbeskrivelse', checked: false },
    qa: { text: 'Q&A', checked: false },
  },
  dokumentType: {
    diverse: {
      text: 'Diverse materialer (afkastrapporter, faktaark, produktpræsentationer mv.)',
      checked: false,
    },
    skabelon: { text: 'Brevskabeloner og blanketter', checked: false },
    forsikringsbetingelser: { text: 'Forsikringsbetingelser', checked: false },
    kundebreve: { text: 'Kundebreve', checked: false },
  },
  tag: {
    livrente: { text: 'Livrente', checked: false },
    doed: { text: 'Risikodækninger - død', checked: false },
    sygdom: { text: 'Risikodækninger - sygdom + helbred', checked: false },
    lts: { text: 'Letsikring til selvstændige', checked: false },
    depotsikring: { text: 'Depotsikring', checked: false },
    p41: { text: '§ 41', checked: false },
    begunstigelse: { text: 'Begunstigelse', checked: false },
    priser: { text: 'Priser og omkostninger', checked: false },
    helbred: { text: 'Helbredsoplysninger', checked: false },
    afkast: { text: 'Afkast, investering, KundeKapital', checked: false },
    produktinfo: { text: 'Produktinfo', checked: false },
    uddannelse: { text: 'Uddannelse', checked: false },
    opsigelse: { text: 'Opsigelse', checked: false },
    varslinger: { text: 'Varslinger', checked: false },
  },
  aar: aarstal(),
};

export const useSearchStore = defineStore('search', () => {
  const searchString = ref('');
  const opslagListe = ref([]);
  const opslagListeUnfiltered = ref([]);
  const loading = ref(false);
  const sorting = ref('relevans');
  const filter = ref(initialFilterValue);
  const filterActive = ref(false);

  async function doSearch(s, force = false) {
    if (s === searchString.value && !force) {
      return;
    }

    searchString.value = s.replaceAll("'", '');

    if (!searchString.value) {
      opslagListe.value = [];
      return;
    }

    loading.value = true;
    const response = await axios.get(getAppConfig().apiRoot + '/api/search', {
      params: {
        criteria: searchString.value,
      },
    });
    loading.value = false;

    const links = [];
    const filer = [];

    if (response.data.links) {
      const linkListe = response.data.links;
      linkListe.forEach((link) => {
        links.push({
          opslagType: 'Link',
          overskrift: link.navn,
          manchet: link.beskrivelse,
          dokumentType: link.soegningFaneblad,
          linkUrl: link.linkUrl,
          linkTarget: link.linkTarget,
          tags: link.tags || [],
          rank: link.rank * 2,
        });
      });
    }

    if (response.data.filer) {
      const filListe = response.data.filer;
      filListe.forEach((fil) => {
        filer.push({
          id: fil.id,
          stinavn: fil.stinavn,
          opslagType: 'Fil',
          overskrift: fil.filnavn,
          manchet: fil.navn,
          dokumentType: fil.dokumentType,
          publiceringsTidspunkt: fil.opdateretDato,
          adgange: fil.adgange,
          tags: fil.tags || [],
          rank: fil.rank * 2,
        });
      });
    }

    const combinedList = []
      .concat(links)
      .concat(filer)
      .concat(response.data.opslag || []);

    // opslagListe.value = sortedList;
    opslagListeUnfiltered.value = combinedList;
    applyFilter();
  }

  function applyFilter() {
    let filteredList = opslagListeUnfiltered.value;
    let active = false;

    //Filtrering på årstal
    const filterAar = [];
    filter.value.aar.forEach((aar) => {
      if (aar.checked) {
        active = true;
        filterAar.push(parseInt(aar.aarstal));
      }
    });
    if (filterAar.length > 0) {
      filteredList = filteredList.filter((x) =>
        filterAar.includes(dayjs(x.publiceringsTidspunkt || 0).year()),
      );
    }

    //Filtrering på opslag eller dokumentType
    const filterOpslagType = [];
    for (let value of Object.values(filter.value.opslagType)) {
      if (value.checked) {
        active = true;
        filterOpslagType.push(value.text);
      }
    }

    const filterDokumentType = [];
    for (let value of Object.values(filter.value.dokumentType)) {
      if (value.checked) {
        active = true;
        filterDokumentType.push(value.text);
      }
    }

    filteredList = filteredList.filter((x) => {
      var showAll = true;
      if (filterOpslagType.length > 0) {
        showAll = false;
        if (filterOpslagType.includes(x.opslagType)) return true;
      }

      if (filterDokumentType.length > 0) {
        showAll = false;
        if (filterDokumentType.includes(x.dokumentType)) return true;
      }
      return showAll;
    });

    //Filtrering på tags
    const filterTags = [];
    for (let value of Object.values(filter.value.tag)) {
      if (value.checked) {
        active = true;
        filterTags.push(value.text);
      }
    }
    if (filterTags.length > 0) {
      filteredList = filteredList.filter((x) =>
        filterTags.some((tag) => x.tags.map((z) => z.navn).includes(tag)),
      );
    }

    //Sortering
    if (sorting.value === 'relevans') {
      opslagListe.value = filteredList.sort((a, b) => (a.rank <= b.rank ? 1 : -1));
    } else {
      opslagListe.value = filteredList.sort((a, b) =>
        (a.publiceringsTidspunkt || 0) < (b.publiceringsTidspunkt || 1) ? 1 : -1,
      );
    }

    filterActive.value = active;
  }

  function clearFilter() {
    for (const [, gruppeValue] of Object.entries(filter.value)) {
      for (const [, feltValue] of Object.entries(gruppeValue)) {
        feltValue.checked = false;
      }
    }
    filterActive.value = false;
  }

  function clearSearch() {
    searchString.value = '';
    opslagListe.value = [];
    clearFilter();
  }

  return {
    searchString,
    filter,
    sorting,
    loading,
    opslagListe,
    doSearch,
    applyFilter,
    clearFilter,
    clearSearch,
    filterActive,
  };
});
